import { Component, EventEmitter, Input, Output } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  DsButtonModule,
  DsFormFieldModule,
  DsFormsModule,
  DsLoadingAreaModule,
  DsMessageModule,
  DsCheckboxModule,
  DsRadioGroupModule,
  DsTableModule,
  DsModalModule,
  DsDatepickerModule,
  DsInputMaskModule,
  DsAccordionModule,
  DsBoxModule,
  DsBadgeModule,
  DsLinkModule,
} from '@bmw-ds/components';

import { CommonModule } from '@angular/common';

import { AllDeactivatedAuthorizedDriverFormGroup } from 'src/app/models/employee-driver-license-and-information.model';

@Component({
  selector: 'app-deactivated-authorized-driver-section',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    DsFormFieldModule,
    DsFormsModule,
    CommonModule,
    DsButtonModule,
    DsLoadingAreaModule,
    DsMessageModule,
    DsModalModule,
    DsCheckboxModule,
    DsRadioGroupModule,
    DsTableModule,
    DsModalModule,
    DsDatepickerModule,
    DsInputMaskModule,
    DsAccordionModule,
    DsBoxModule,
    DsBadgeModule,
    DsLinkModule,
  ],
  templateUrl: './deactivated-authorized-driver-section.html',
  styleUrl: './deactivated-authorized-driver-section.scss',
})
export class DeactivatedAuthorizedDriverSection {
  @Output() reactivateAuthorizedDriver = new EventEmitter<void>();
  @Input()
  deactivatedAuthorizedDriverForms!: AllDeactivatedAuthorizedDriverFormGroup;

  handleSubmit() {}

  handleDeleteAuthorizedDriver() {}
  handleReactivateAuthorizedDriver() {}

  handleSendConsentEmail() {}
  handleAddAuthorizedDriver() {}
}
